<template>
  <a-spin :spinning="spinning">
    <a-form :form="form">

      <a-form-item label="标题" :labelCol="labelCol" :wrapperCol="wrapperCol">
        <a-input
          name="name"
          v-decorator="['name', { rules: [{ required: true, message: '请输入友链名称' }] }]"
        />
      </a-form-item>
      <a-form-item label="所属分类" :labelCol="labelCol" :wrapperCol="wrapperCol">
        <a-spin :spinning="categoriesLoad">
          <a-select
            placeholder="请选择分类"
            style="width: 100%"
            name="category"
            optionFilterProp="children"
            allow-clear
            v-decorator="['category', { rules: [{ required: true, message: '请选择分类' }] }]"
          >
            <a-select-option v-for="cat in categoriesLists" :key="cat.id">{{
              cat.name
            }}</a-select-option>
          </a-select>
        </a-spin>
      </a-form-item>
      <a-form-item label="上传LOGO" :labelCol="labelCol" :wrapperCol="wrapperCol">
        <img-upload
          name="thum"
          v-decorator="['logo', { rules: [{ required: true, message: '请上传LOGO' }] }]"
        />
      </a-form-item>
      <a-form-item label="链接" :labelCol="labelCol" :wrapperCol="wrapperCol">
        <a-input
          name="href"
          v-decorator="['href', { rules: [{ type: 'url', message: '请输入正确的链接' }] }]"
        />
      </a-form-item>
      <a-form-item label="排序" :labelCol="labelCol" :wrapperCol="wrapperCol" help="默认0，值越大越靠前">
        <a-input
          name="order"
          v-decorator="[
            'order',
            {
              initialValue: 0
            }
          ]"
        />
      </a-form-item>
      <a-form-item label="状态" :labelCol="labelCol" :wrapperCol="wrapperCol" help="默认展示">
        <a-switch
          checked-children="展示"
          un-checked-children="隐藏"
          name="state"
          v-decorator="[
            'state',
            {
              valuePropName: 'checked',
              initialValue: true
            }
          ]"
        />
      </a-form-item>
    </a-form>
  </a-spin>
</template>

<script>
import pick from 'lodash.pick'
import { select } from '@/mixins'
import { ImgUpload } from '@/components'
import { requestGet, requestPost, requestPut } from '@/api/api'
const fields = ['name', 'href', 'logo', 'order', 'state', 'category']

export default {
    name: 'ModelForm',
    mixins: [select],
    props: {
        aid: {
            type: Number,
            default: null
        }
    },
    components: {
        ImgUpload
    },
    data () {
        return {
            categoriesLists: [],
            categoriesLoad: false,
            spinning: false, // 页面加载
            labelCol: {
                xs: { span: 24 },
                sm: { span: 7 }
            },
            wrapperCol: {
                xs: { span: 24 },
                sm: { span: 13 }
            },
            form: this.$form.createForm(this)
        }
    },
    mounted () {
        if (this.aid) {
            this.getLink(this.aid) // 获取编辑友链信息
        }

        if (this.$route.params.id) {
          this.getFormData(this.$route.params.id, function (values) {
                values.state = values.state === 1 // 状态格式转换
                values.allow_buy = values.allow_buy === 1 // 状态格式转换
                values.price = values.price / 100 // 状态格式转换
                values.is_baidu = values.is_baidu.toString()
                this.selectMode = values.is_baidu.toString()
            })
        }

        this.getSelectLists({
            url: 'partners/link/category/select',
            type: 'categoriesLists',
            load: 'categoriesLoad'
        })
    },
    methods: {
        /**
         * 获取编辑友链信息
         * @id
         */
        getLink (id) {
            this.spinning = true
            requestGet('/partners/links/' + id)
                .then(res => {
                    res.result.state = res.result.state === 1
                    setTimeout(() => {
                        this.form.setFieldsValue(pick(res.result, fields))
                    }, 1000)
                })
                .finally(() => {
                    this.spinning = false
                })
        },
        /**
         * 提交按钮
         * form表单提交
         * @form
         */
        onOk () {
            const {
                form: { validateFields }
            } = this
            return new Promise(resolve => {
                validateFields((errors, values) => {
                    if (!errors) {
                        values.state = values.state ? 1 : 2 // 状态 1正常 2隐藏
                        if (this.aid) {
                            const url = '/partners/links/' + this.aid
                            requestPut(url, values)
                                .then(res => {
                                    this.$notification.success({
                                        message: '提示',
                                        description: res.msg,
                                        duration: 2
                                    })
                                    resolve(true)
                                })
                        } else {
                            const url = '/partners/links/create'
                            requestPost(url, values)
                                .then(res => {
                                    this.$notification.success({
                                        message: '提示',
                                        description: res.msg,
                                        duration: 2
                                    })
                                    resolve(true)
                                })
                        }
                    }
                })
            })
        },
        onCancel () {
            return new Promise(resolve => {
                resolve(true)
            })
        }
    }
}
</script>

<style>
.avatar-uploader > .ant-upload {
    width: 128px;
    height: 128px;
}
.ant-upload-select-picture-card i {
    font-size: 32px;
    color: #999;
}

.ant-upload-select-picture-card .ant-upload-text {
    margin-top: 8px;
    color: #666;
}
</style>
